import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MapPin, Clock } from 'lucide-react';
import { salonInfo } from '../data/mockData';

export const Footer = () => {
  return (
    <footer className="bg-dark text-white">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & About */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_d2fafa34-76d1-4e50-83f7-dffe77c91e9f/artifacts/q0u25lu4_Logo.JPG" 
              alt="Ginos Friseure Logo" 
              className="h-16 w-auto brightness-0 invert"
            />
            <p className="text-subtle-light text-sm leading-relaxed">
              {salonInfo.motto}
            </p>
            <div className="flex items-center space-x-4">
              <a 
                href={salonInfo.contact.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link">
                  Home
                </Link>
              </li>
              <li>
                <a href="/#about" className="footer-link">
                  Über Uns
                </a>
              </li>
              <li>
                <a href="/#services" className="footer-link">
                  Services
                </a>
              </li>
              <li>
                <Link to="/pricelist" className="footer-link">
                  Preisliste
                </Link>
              </li>
              <li>
                <a href="/#gallery" className="footer-link">
                  Galerie
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-accent mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <p>{salonInfo.address.street}</p>
                  <p>{salonInfo.address.district}</p>
                  <p>{salonInfo.address.postalCode} {salonInfo.address.city}</p>
                </div>
              </li>
              <li>
                <a 
                  href={salonInfo.contact.treatwell}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary inline-block"
                >
                  Termin buchen
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-lg font-bold mb-6">Öffnungszeiten</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex justify-between">
                <span className="text-subtle-light">Montag:</span>
                <span>{salonInfo.hours.monday}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-subtle-light">Dienstag:</span>
                <span>{salonInfo.hours.tuesday}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-subtle-light">Mittwoch:</span>
                <span>{salonInfo.hours.wednesday}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-subtle-light">Donnerstag:</span>
                <span>{salonInfo.hours.thursday}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-subtle-light">Freitag:</span>
                <span>{salonInfo.hours.friday}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-subtle-light">Samstag:</span>
                <span>{salonInfo.hours.saturday}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-subtle-light">Sonntag:</span>
                <span>{salonInfo.hours.sunday}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 text-center text-sm text-subtle-light">
          <p>&copy; {new Date().getFullYear()} Ginos Friseure Düsseldorf. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};
